/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

/**
 * Downloads a blob as file.
 * @param blob
 * @param filename
 */
export function downloadBlob (blob: Blob, filename: string): void {
  // Convert your blob into a Blob URL
  // (a special url that points to an object in the browser's memory)
  const blobUrl = URL.createObjectURL(blob)

  // Create a link element
  const link = document.createElement('a')

  // Set link's href to point to the Blob URL
  link.href = blobUrl
  link.download = filename

  // Append link to the body
  document.body.appendChild(link)

  // Dispatch click event on the link
  // This is necessary as link.click() does not work on the latest firefox
  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    })
  )

  // Remove link from body.
  document.body.removeChild(link)

  // Free URL resource to allow next download to happen.
  URL.revokeObjectURL(blobUrl)
}

/**
 * Extracts filename in Content-Disposition.
 * @param contentDisposition
 */
export function getFilenameFromContentDisposition (contentDisposition: string): string | null {
  const target = 'filename='
  const text = contentDisposition.toLowerCase().replace(/"/g, '')
  const index = text.indexOf(target)
  return index !== -1
    ? text.substring(index + target.length)
    : null
}

/**
 * Downloads blob as file using content-disposition for filename.
 * @param resp
 */
export async function handleBlobResponse (resp: Response): Promise<Blob> {
  const blob = await resp.blob()
  const contentDisposition = resp.headers.get('Content-Disposition')
  let filename: string | null = null

  if (contentDisposition != null) {
    filename = getFilenameFromContentDisposition(contentDisposition)
  }
  if (filename == null) {
    filename = 'download'
    // todo add file extension
  }
  downloadBlob(blob, filename)
  return blob
}

/**
 Opens a dialog to select a single file.
 * @param callback
 * @param options
 */
export function selectFile (callback: (file: File) => void, options?: { accept?: string }): void {
  const input = document.createElement('input')
  input.accept = options?.accept
  input.name = 'selected_file'
  input.type = 'file'
  input.addEventListener('change', () => {
    if (input.files) {
      const file = input.files.item(0)
      if (file != null) {
        callback(file)
      }
    }
  })
  input.click()
}

/**
 * Opens a dialog to select multiple files.
 * @param callback
 * @param options
 */
export function selectFiles (callback: (files: FileList) => void, options?: {
  accept?: string
}): void {
  const input = document.createElement('input')
  input.accept = options?.accept
  input.name = 'selected_file'
  input.multiple = true
  input.type = 'file'
  input.addEventListener('change', () => {
    if (input.files) {
      callback(input.files)
    }
  })
  input.click()
}
